module.exports = __webpack_public_path__ + "img/main_yxzh.ab944131.jpg";